import { ROLES } from '@/constants/roles';

export const settings = {
  path: '/settings/appearance',
  name: 'settings',
  component: () => import('./views/Appereance/index.vue'),
  meta: {
    title: 'Настройки',
    icon: 'mdi-cog',
    accessList: [ROLES.operator, ROLES.department],
    instruction: {
      id: 11,
      name: 'Основные настройки',
    },
    children: [
      {
        text: 'Основные настройки',
        to: '/settings/appearance',
        icon: 'mdi-microsoft-xbox-controller-view',
        visibleFor: [ROLES.operator],
      },
      {
        text: 'Модераторы',
        to: '/moderators',
        icon: 'mdi-account-multiple-outline',
        visibleFor: [ROLES.operator, ROLES.department],
      },
      // {
      //   text: 'Начисление баллов',
      //   to: '/settings/scores',
      //   icon: 'mdi-surround-sound-7-1',
      //   visibleFor: [ROLES.operator],
      // },
      // {
      //   text: 'Требования к командам',
      //   to: '/settings/team-requirements',
      //   icon: 'mdi-human-capacity-increase',
      // },
      // {
      //   text: 'Коэффициенты значимости',
      //   to: '/settings/significance-coefficient',
      //   icon: 'mdi-playlist-star',
      //   visibleFor: [ROLES.operator],
      // },
      // {
      //   text: 'Использование документов',
      //   to: '/settings/document-uses',
      //   icon: 'mdi-file-document-edit-outline',
      //   visibleFor: [ROLES.operator],
      // },
    ],
  },
};

export const uiSettings = {
  path: '/operator-settings',
  name: 'ui-settings',
  component: () => import('./views/Appereance/index.vue'),
  meta: {
    title: 'Настройки',
    layout: 'ui-design',
    accessList: [ROLES.operator],
    instruction: {
      id: 11,
      name: 'Основные настройки',
    },
  },
  props: {
    hideTitle: true,
  },
};

export const tools = {
  path: '/tools',
  name: 'tools',
  meta: {
    title: 'Инструменты',
    icon: 'mdi-hammer-wrench',
    children: [
      {
        text: 'Адреса проведения',
        icon: '$iweb',
        to: '/settings/addresses',
        visibleFor: [ROLES.organization],
      },
      // NOTE: решили скрыть раздел, возможно, временно
      // {
      //   text: 'Номинации',
      //   icon: '$istar-outline',
      //   to: '/nominations',
      //   visibleFor: [ROLES.organization],
      // },
      {
        text: 'Задания и КИМы',
        icon: '$iedit',
        to: '/polls',
        visibleFor: [ROLES.organization],
      },
    ],
  },
};

export const settingsAddresses = {
  path: '/settings/addresses',
  name: 'settings-addresses',
  component: () => import('./views/Addresses/index.vue'),
  meta: {
    title: 'Адреса проведения',
    icon: '$iweb',
    layout: 'ui-design',
    accessList: [ROLES.organization],
    instruction: {
      id: 45,
      name: 'Адреса проведения',
    },
  },
};

// export const settingsScores = {
//   path: '/settings/scores',
//   component: () => import('./views/Scores/index.vue'),
//   meta: {
//     accessList: [ROLES.operator],
//     instruction: {
//       id: 34,
//       name: 'Начисление баллов',
//     },
//   },
// };

export const settingsTeamRequirements = {
  path: '/settings/team-requirements',
  component: () => import('./views/TeamRequirements/index.vue'),
  meta: {
    accessList: [ROLES.operator],
    instruction: {
      id: 32,
      name: 'Требования к командам',
    },
  },
};

// export const settingsSignificanceCoefficient = {
//   path: '/settings/significance-coefficient',
//   component: () => import('./views/SignificanceCoefficient/index.vue'),
//   meta: {
//     accessList: [ROLES.operator],
//     instruction: {
//       id: 10,
//       name: 'Коэффициенты значимости',
//     },
//   },
// };

export const settingsDocument = {
  path: '/settings/document-uses',
  component: () => import('./views/DocumentUses/index.vue'),
  meta: {
    accessList: [ROLES.operator],
  },
};

export default [settings, uiSettings, settingsAddresses, settingsTeamRequirements, settingsDocument];
